import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  unAssignManagerFromResource(
    request: Boundaries["unAssignManagerFromResource"]["request"],
  ): void;
}

function useUnAssignManagerFromResource(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestFailure(resource),
    ),
    unAssignManagerFromResource: core.unAssignManagerFromResource,
  };
}

export { useUnAssignManagerFromResource };
